const autoNgTemplateLoaderTemplate1 = require('./edgeStacksDatatable.html');

import angular from 'angular';
import './edgeStackDatatable.css';

angular.module('portainer.edge').component('edgeStacksDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'GenericDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    removeAction: '<',
    refreshCallback: '<',
  },
});
